export default __webpack_public_path__ + "static/media/power_grey_slash.39b452ae.svg";